import React, { useEffect, useState } from "react";


export default function ObfuscatedEmail({ user, domain, className = "" }) {
    const [revealed, setRevealed] = useState(false);

    useEffect(() => {
        if (typeof document !== "undefined" && typeof window !== "undefined") {
            setRevealed(true);
        }
    }, []);

    if (!revealed) {
        return (
            <span className={className} data-testid="obfuscated-email">
                [email&nbsp;protected]
            </span>
        );
    }

    const address = `${user}@${domain}`;
    return (
        <a href={`mailto:${address}`} className={className} data-testid="obfuscated-email">
            {address}
        </a>
    );
}
